import { createStore, applyMiddleware } from 'redux';
import { config } from './config';
import Logger from 'redux-logger';
import reduxThunk from 'redux-thunk';

import reducers from './reducers';
import { loadState, saveState } from './localStorage'

var store = undefined;

export default {
	init() {
		let createStoreWithMiddleware;
		const persistedState = loadState();
		if (config.LOGGER == 1) {
			createStoreWithMiddleware = applyMiddleware(reduxThunk, Logger)(createStore);
		} else {
			createStoreWithMiddleware = applyMiddleware(reduxThunk)(createStore);
		}
		if (process.env.NODE_ENV === 'development') {
			store = createStoreWithMiddleware(reducers, persistedState, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
		} else {
			store = createStoreWithMiddleware(reducers, persistedState);
			
		}
		this.subscribeToStateChange();
		return store;
	},
	subscribeToStateChange() {
		store.subscribe(() => {
			const state = store.getState();
			saveState(state);
		});
	},
	getStore() {
		return store;
	}
}